import {createElement} from "@opendaw/lib-jsx"

export const FileIcon = () => (
    <svg className="file" viewBox="0 0 24 24" fill="currentColor">
        <path
            d="M21 9V20.9925C21 21.5511 20.5552 22 20.0066 22H3.9934C3.44495 22 3 21.556 3 21.0082V2.9918C3 2.45531 3.44694 2 3.99826 2H14V8C14 8.55228 14.4477 9 15 9H21ZM21 7H16V2.00318L21 7Z"/>
    </svg>
)
